import { Notification } from '@hefe/models';
import { markUserNotificationAsRead, ModalsSlice } from '@hefe/store';
import { colors, getNotificationIcon } from '@hefe/ui';
import { Badge, Col, Divider, Row, Space, Typography } from 'antd';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../store/store';
import { notificationNavigateTo } from '../../helpers/notifications.helpers';

interface NotificationsListItemComponentProps {
  notification: Notification;
}

export default function NotificationsListItemComponent(
  props: NotificationsListItemComponentProps
) {
  const { notification } = props;

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const Icon = useMemo(() => {
    return getNotificationIcon(notification.data.icon);
  }, [notification]);

  const markNotificationAsRead = () => {
    dispatch(markUserNotificationAsRead(notification));
  };

  const onNotificationClick = () => {
    markNotificationAsRead();

    notificationNavigateTo(notification.data, navigate, dispatch);
  };

  return (
    <Row
      align="middle"
      style={{ cursor: 'pointer' }}
      onClick={() => onNotificationClick()}
    >
      <Col xs={4}>
        <Badge dot={!notification.read_at} size="default">
          <Icon
            size={24}
            color={!notification.read_at ? colors.primary : undefined}
          />
        </Badge>
      </Col>
      <Col xs={20}>
        <Space direction="vertical" size={0}>
          <Typography.Text strong>{notification.data.title}</Typography.Text>
          <Typography.Text style={{ fontSize: 12 }}>
            {notification.data.text}
          </Typography.Text>
        </Space>
      </Col>
      <Divider style={{ margin: '10px 0px 10px 0px' }} />
    </Row>
  );
}
